import { Flex, Text as MantineText } from '@mantine/core';
import {
	DocumentWorkflowInstanceSignatureStatus,
	InvestorDocumentWorkflowCounterpartySignatureRes,
	SignatureType,
} from '@dealstack/shared/lib/generated';
import {
	CHIP_THEME,
	Chips as ChipsV2,
	COLOR,
} from '@dealstack/frontend/shared/components/Chips/Chips.v2';
import { StyledSignedChip } from '@dealstack/frontend/investor/pages/Investment/common/DocumentWorkflowContracts/styled';
import { mapStatusToChipVariant } from '@dealstack/frontend/investor/pages/Investment/common/DocumentWorkflowContracts/types';
import { CounterpartySignatureWrapper } from './InvestorDocumentWorkflowTable.styles';
import { WitnessChip } from './WitnessChip';

interface Props {
	signatures: InvestorDocumentWorkflowCounterpartySignatureRes[];
	signatureType: string | null;
}

export const CounterpartySignatureCell = ({ signatures, signatureType }: Props) => {
	if (!signatures.length) {
		return (
			<CounterpartySignatureWrapper>
				<MantineText size="sm">-</MantineText>
			</CounterpartySignatureWrapper>
		);
	}

	if (signatures.length === 1) {
		const signature = signatures[0];
		const variant = mapStatusToChipVariant(
			(signature.status as DocumentWorkflowInstanceSignatureStatus) ??
				DocumentWorkflowInstanceSignatureStatus.CREATED,
			(signatureType as SignatureType) ?? 'WET_INK'
		);
		return (
			<CounterpartySignatureWrapper>
				<Flex gap="xs" align="center">
					<StyledSignedChip variant={variant} />
					{WitnessChip(signature.witness)}
				</Flex>
			</CounterpartySignatureWrapper>
		);
	}

	const signedCount = signatures.filter(
		(s) =>
			s.status === DocumentWorkflowInstanceSignatureStatus.SIGNED ||
			s.status === DocumentWorkflowInstanceSignatureStatus.COMPLETED
	).length;
	const totalCount = signatures.length;
	const allSigned = signedCount === totalCount;

	return (
		<CounterpartySignatureWrapper>
			<ChipsV2
				outline
				size="s"
				color={allSigned ? COLOR.GREEN : COLOR.YELLOW}
				chipTheme={CHIP_THEME.LIGHT}
				prefixIcon="signed"
			>
				{`${signedCount}/${totalCount}`}
			</ChipsV2>
		</CounterpartySignatureWrapper>
	);
};
